import requests from "./httpService";
import axios from "axios";

const RequestServies = {
    createRequest: async (body) => {
        return requests.post("/request", body);
    },

    getRequest: async (store, status) => {
        return requests.get(`/request?query=${store}&status=${status}`);
    },

    getRequestDashboardDataByRequisitionNo: async (body) => {
        return requests.post(
            "/request/getRequestDashboardDataByRequisitionNo",
            body
        );
    },

    searchRequestDashboardData: async (body) => {
        return requests.post("/request/searchRequestDashboardData", body);
    },

    pendingPOReceiving: async (body) => {
        return requests.post("/request/pending-po-receiving", body);
    },

    pendingLocalReceiving: async (body) => {
        return requests.post("/request/pending-local-receiving", body);
    },

    requestPOCancellation: (body) => {
        return requests.patch("/request/request-po-cancellation", body);
    },

    getCancellationRequests: async (body = {}) => {
        return requests.post("/request/getCancellationRequests", body);
    },

    rejectCancellationRequest: async (itemIds, remark) => {
        return requests.patch("/request/rejectCancellationRequest", {
            itemIds,
            remark,
        });
    },

    getCancellationHistory: async (requisitionId) => {
        return requests.post("/request/getCancellationHistory", {
            requisitionId,
        });
    },

    cancelFullRequisition: (id, data) => {
        return requests.patch(
            `/request/cancel-full-requisition/${id}`,
            data
        );
    },

    getAllRequestDashboradData: async () => {
        return requests.get("/request/dashboard-data");
    },

    updateRequest: async (id, body) => {
        return requests.patch(`/request/${id}`, body);
    },

    reverseRequisitionsToStorekeeper: async (payload) => {
        return requests.patch(
            "/request/reverse-to-storekeeper",
            payload
        );
    },

    getHoReturnedItemsByStore: async (storeId) => {
        return requests.get(
            `/request/ho-returned-items?storeId=${encodeURIComponent(storeId)}`
        );
    },

    mergeHoReturnedRequisitions: async (payload) => {
        return requests.post("/request/merge-ho-returned", payload);
    },

    createItem: async (body) => {
        return requests.post("/item", body);
    },

    updateItemQty: async (id, body) => {
        return requests.put(`/item/qty/${id}`, body);
    },

    createTransfer: async (body) => {
        return requests.post("/transfer", body);
    },

    getTrasfer: async (store, status) => {
        return requests.get(
            `/transfer?query=${store}&status=${status}`
        );
    },

    submitTransfer: async (body) => {
        return requests.post("/transfer/submit", body);
    },

    getAllItem: async (reqNo, status, store, poStatus) => {
        return requests.get(
            `/item?reqNo=${reqNo}&status=${status}&store=${store}&poStatus=${poStatus}`
        );
    },

    getItemsByRequisitionNo: async (requisitionId) => {
        return requests.get(`/item/request/${requisitionId}`);
    },

    getEligibleBillsDispatch: async (store, fromDate, toDate) => {
        return requests.get("/mrv/eligible-Bills-Dispatch", {
            params: { store, fromDate, toDate },
        });
    },

    getEligibleBillsByStore: async (store) => {
        return requests.get("/mrv/eligible-bills-by-store", {
            params: { store },
        });
    },

    getAllItemApproval: async (reqNo) => {
        return requests.get(
            `/item/getallitem/item?reqNo=${reqNo}`
        );
    },

    getDesileItem: async (status, store) => {
        return requests.get(
            `/item/desile/item?status=${status}&store=${store}`
        );
    },

    updateItem: async (id, body) => {
        return requests.patch(`/item/${id}`, body);
    },

    CancelItem: async (id, data) => {
        return requests.patch(
            `/item/${id}/cancel-remaining`,
            data
        );
    },

    report: async (body) => {
        return requests.post("/item/report", body);
    },

    downloadRequisitionReport: async (data) => {
        return axios.post(
            "/api/v1/item/report/download",
            data,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    accountsItemReport: async (data) => {
        return axios.post(
            "/api/v1/item/report/accounts-item/download",
            data,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    reportUsedItems: async (body) => {
        return requests.post("/useditem/report", body);
    },

    downloadMIVReport: async (data) => {
        return axios.post(
            "/api/v1/useditem/report/download",
            data,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    reportTransferItems: async (body) => {
        return requests.post("/transferItem/report", body);
    },

    downloadTransferReport: async (data) => {
        return axios.post(
            "/api/v1/transferItem/report/download",
            data,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );
    },

    reportGroupRequistion: async (body) => {
        return requests.post("/item/itemreport", body);
    },

    reportGroupItems: async (body) => {
        return requests.post("/useditem/itemreport", body);
    },

    submitRequisition: async (body) => {
        return requests.post("/request/submitrequisition", body);
    },

    newSubmitRequisition: async (body) => {
        return requests.post("/request/newSubmitrequisition", body);
    },

    newSubmitRequistBySuperAdmin: async (body) => {
        return requests.post(
            "/request/superadmin/create-priority-requisition",
            body
        );
    },

    submitfordesile: async (body) => {
        return requests.post("/desile", body);
    },

    submitfordesileUsed: async (body) => {
        return requests.post("/desile", body);
    },

    submitMiv: async (body) => {
        return requests.post("/miv/submitmiv", body);
    },

    newsubmitMiv: async (body) => {
        return requests.post("/miv/newsubmitmiv", body);
    },

    machineDieselHistory: async (body) => {
        return requests.post("/miv/machineDieselHistory", body);
    },

    submitMrv: async (body) => {
        return requests.post("/mrv/submitmrv", body);
    },

    localsubmitMrv: async (body) => {
        return requests.post("/mrv/localsubmitmrv", body);
    },

    getMrvByBillingNos: async (billingNos) => {
        return requests.post("/mrv/mrv-by-billing", {
            billingNos,
        });
    },

    getSingleMrv: async (id) => {
        return requests.get(`/mrv/${id}`);
    },

    updateBillCheckedStatus: async (mrvId, billChecked) => {
        return requests.patch(
            `/mrv/${mrvId}/bill-checked`,
            { billChecked }
        );
    },

    submitDesile: async (body) => {
        return requests.post("/mrv/desile/submitmrv", body);
    },

    mrvbyStoreAndStatus: async (
        store = "",
        status = "",
        selectedRole = ""
    ) => {
        const params = new URLSearchParams();

        if (store) {
            params.append("store", store);
        }

        if (status && status !== "all") {
            params.append("status", status);
        }

        if (selectedRole) {
            params.append("selectedRole", selectedRole);
        }

        const queryString = params.toString();

        return requests.get(
            `/mrv/mrvbyStoreAndStatus${queryString ? `?${queryString}` : ""}`
        );
    },

    mrvBillAction: async (data) => {
        return requests.patch("/mrv/mrvBillAction", data);
    },

    submitTransferMrv: async (body) => {
        return requests.post("/mtn/submitTransferMrv", body);
    },

    createMrv: async (body, onUploadProgress) => {
        return requests.post("/mrv", body, {
            onUploadProgress,
        });
    },

    createMtn: async (body) => {
        return requests.post("/mtn", body);
    },

    getMrv: async (store) => {
        return requests.get(`/mrv?query=${store}`);
    },

    getMtn: async (store) => {
        return requests.get(`/mtn?query=${store}`);
    },

    createMiv: async (body) => {
        return requests.post("/miv", body);
    },

    getMiv: async (store, status) => {
        return requests.get(
            `/miv?query=${store}&status=${status}`
        );
    },

    createUsedItem: async (body) => {
        return requests.post("/useditem", body);
    },

    getAllUsedItem: async () => {
        return requests.get("/useditem");
    },

    getUsedItemByMiv: async (mivId) => {
        return requests.get(`/useditem/miv/${mivId}`);
    },

    updateUsedItem: async (id, body) => {
        return requests.patch(`/useditem/${id}`, body);
    },

    getTransferAllItem: async (store, status) => {
        return requests.get(
            `/transferItem?query=${store}&status=${status}`
        );
    },

    getTransferedItem: async (store, status) => {
        return requests.get(
            `/transferItem/to?query=${store}&status=${status}`
        );
    },

    getFabrication: async (store, status) => {
        return requests.get(
            `/fabrication?storeId=${store}&status=${status}`
        );
    },

    submitFabrication: async (body) => {
        return requests.post("/fabrication", body);
    },

    submitCompleteFabrication: async (body) => {
        return requests.post(
            "/fabrication/trade/recived",
            body
        );
    },

    reportFabrication: async (body) => {
        return requests.post("/fabrication/report", body);
    },

    getdocumetwithitems: async (body) => {
        return requests.post("/dashboard/getitem", body);
    },
};

export default RequestServies;